<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <v-footer
      class="font-weight-medium primary"
    >
      <v-container class="box-copy">
        <v-col class="text-left white--text box-txt-copy" cols="10">
          <div>
            <a href="http://politicadecookies.editoradobrasil.com.br" target="_blank">Política de Cookies</a> e 
            <a href="https://conteudos.editoradobrasil.com.br/politicas/politicas-de-cookies-e-privacidade.pdf" target="_blank">Política de Privacidade</a>
          </div>
        Editora do Brasil S.A.,
          {{ new Date().getFullYear() }}.
          Todos os direitos reservados. Proibida venda ou compartilhamento total ou parcial do arquivo.
        </v-col>
      </v-container>  
    </v-footer>
  </v-app>
</template>

<script>
//import Home from './components/Home';

export default {
  name: 'App',

  // components: {
  //   Home,
  // },

  data: () => ({
    drawer: false,
    userName: "",
  }),
  watch: {
    group () {
      this.drawer = false
    },
    //userName: function (val) {
      //if(val == ""){ return; }
      //this.abrirFlipbook(val.arquivo);
      //console.log(val);
      //this.query = "";
      //this.selected = "";
    //}
  },
  created() {
    try {
        const storage = JSON.parse(localStorage.getItem('user'));
        this.userName =  storage.userName.split(' ')[0];
        //this.Usuario = storage.usuario.nome
        //this.Guid = storage.usuario.guid
    }
    catch (error) {
      console.log(error);
    }
  },
  methods: {
      sair() {
      let self = this;
      localStorage.clear();
      self.$router.push('/');
    }
  }
};
</script>
<style lang="scss">
header {
  background: rgba(255, 255, 255, 0.4) !important;
  .v-toolbar__title {
    font-size: 36px !important;
  }
  .v-btn__content {
    font-weight: bold;
  }
  .v-icon {
    color:#19286E !important;
  }
}
.menu-header-mobile {
  a {
    text-decoration: none;
    display: block;
  }
}
</style>
